<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/company'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      formModel: {
        IsDefault: "Y",
        ManufactureFlag: "N",
        IsDefaultData: false,
        SetDefault: true,
        Inactive: true,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Division",
        pageRoute: "/division",
        saveEndPoint: "Division",
        recordEndPoint: "Division",
        isDefaultEndPoint: "Save_DefaultDivision",
        exportFileName: "Division List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "Division",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "division",
              mode: "review",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: false,
            export: true,
            openFilter: false,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/division/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Division",
              caption: "UM",
              sortOrder: "asc",
              sortIndex: 0,
              dataField: "Code",
              gridDataField: "Code",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "Code",
                  label: "Division Code",
                },
                {
                  dataField: "Description",
                  label: "Division Description",
                },
              ],
            },
            {
              screenField: "IsDefault",
              makeDisabled: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.Inactive == "Y"
                );
              },
            },
            {
              screenField: "Status",
              // filterDataField: "FriendlyInactive",
              filterIndex: 0,
            },
          ],
        },
      },
    };
  },
  methods: {
    overWritePayload(payload) {
      payload.ManufactureFlag = this.formModel["ManufactureFlag"] == true ? "Y" : "N";
      return payload;
    },
  },
  computed: {
    setDefaultEdit() {
      return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                required: true,
                allowUpdate: this.baseView.mode == "edit" ? false : true,
                screenField: "Division",
                isPrimaryKeyField: true,
              },
              {
                dataField: "Description",
                required: true,
                screenField: "Name",
              },

              {
                dataField: "SetDefault",
                editorOptions: {
                  readOnly: this.setDefaultEdit,
                },
                screenField: "IsDefault",
              },
              {
                screenField: "ManufactureFlag",
                editorOptions: {
                  onInitialized: (e) => {
                      e.component.beginUpdate();
                      e.component.option("value", this.formModel["ManufactureFlag"] == "Y" ? true : false);
                      e.component.endUpdate();
                  },
                },
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
  },
};
</script>
